import { Route } from "react-router";
import { all_routes } from "./all_routes";

// Admin components
import UserManagement from "../admin/users/UserManagement";
import DocumentRequestsManagement from "../admin/documents/DocumentRequestsManagement";
import SchoolSchedule from "../admin/schedule/SchoolSchedule";
import NotificationSettings from "../admin/notifications/NotificationSettings";
import AdminSettings from "../admin/settings/AdminSettings";

// Teacher components
import AttendanceTracker from "../teacher/attendance/AttendanceTracker";
import ManageHomework from "../teacher/homework/ManageHomework";
import AlertParents from "../teacher/alerts/AlertParents";
import TeacherSchedule from "../teacher/schedule/TeacherSchedule";
import GradeEntry from "../teacher/grades/GradeEntry";

// Teacher Module - Complete App Flow Components
import TeacherTasks from "../teacher/tasks/TeacherTasks";
import TeacherMenu from "../teacher/menu/TeacherMenu";
import TeacherClasses from "../teacher/classes/TeacherClasses";
import StudentsDirectory from "../teacher/students/StudentsDirectory";
import ReportStudent from "../teacher/reports/ReportStudent";
import DocumentRequests from "../teacher/documents/DocumentRequests";
import LeaveRequests from "../teacher/leave/LeaveRequests";
import ContactAdmin from "../teacher/admin/ContactAdmin";
import ReportIssues from "../teacher/issues/ReportIssues";

// Teacher Module - Additional Components
import TeacherProfile from "../teacher/profile/TeacherProfile";
import TeacherSettings from "../teacher/settings/TeacherSettings";
import TeacherHelp from "../teacher/help/TeacherHelp";
import TeacherMessages from "../teacher/messages/TeacherMessages";
import TeacherNotifications from "../teacher/notifications/TeacherNotifications";
import TeacherAttendanceHistory from "../teacher/attendance/AttendanceHistory";
import TeacherHomeworkHistory from "../teacher/homework/HomeworkHistory";
import AnnouncementsSent from "../teacher/announcements-sent/AnnouncementsSent";
import TeacherAnalytics from "../teacher/analytics/TeacherAnalytics";
import TeacherGradesOverview from "../teacher/grades/TeacherGradesOverview";

// Student components
import GradeList from "../student/grades/GradeList";
import DocumentRequestForm from "../student/documents/DocumentRequestForm";
import AttendanceView from "../student/attendance/AttendanceView";
import ToDoList from "../student/dashboard/ToDoList";
import StudentClasses from "../student/classes/StudentClasses";
import StudentTasks from "../student/tasks/StudentTasks";
import StudentMenu from "../student/menu/StudentMenu";
import StudentEvents from "../student/events/StudentEvents";
import StudentMessages from "../student/messages/StudentMessages";
import StudentNotifications from "../student/notifications/StudentNotifications";
import StudentHelp from "../student/help/StudentHelp";
import StudentSettings from "../student/settings/StudentSettings";

// Parent components
import ViewStudentProfile from "../parent/student-info/ViewStudentProfile";
import PaymentHistory from "../parent/payments/PaymentHistory";
import StudentGrades from "../parent/grades/StudentGrades";
import ParentDocumentRequests from "../parent/documents/DocumentRequests";

// Parent Module - New Components
import ParentHomework from "../parent/homework/ParentHomework";
import ParentTasks from "../parent/tasks/ParentTasks";
import ParentMenu from "../parent/menu/ParentMenu";
import ParentAttendanceHistory from "../parent/attendance/AttendanceHistory";
import ParentSchedule from "../parent/schedule/ParentSchedule";
import ParentHomeworkHistory from "../parent/homework/ParentHomework";
import ParentGradesOverview from "../parent/grades/GradesOverview";
import ParentPaymentsHistory from "../parent/payments/PaymentHistory";
import ParentDocuments from "../parent/documents/DocumentRequests";
import ParentEventsCalendar from "../parent/events/EventsCalendar";
import ParentMessages from "../parent/messages/ParentMessages";
import ParentNotifications from "../parent/notifications/ParentNotifications";
import ParentSettings from "../parent/settings/ParentSettings";
import ParentHelp from "../parent/help/ParentHelp";

// Support components
import SupportDashboard from "../support/dashboard/SupportDashboard";
import SupportUserAccess from "../support/users/SupportUserAccess";
import AllDocumentRequests from "../support/documents/AllDocumentRequests";
import ReportedIssues from "../support/issues/ReportedIssues";

// // Essential utilities
// import Countries from "../content/location/countries";
// import Cities from "../content/location/cities";
// import States from "../content/location/states";
import Calendar from "../mainMenu/apps/calendar";
import DataTable from "../tables/dataTable";
import BasicTable from "../tables/basicTable";

// Auth
import Login from "../auth/login/login";
import Register from "../auth/register/register";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import EmailVerification from "../auth/emailVerification/emailVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import LockScreen from "../auth/lockScreen";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";

// Error pages
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import UnderMaintenance from "../pages/underMaintenance";

// Dashboards
import AdminDashboard from "../admin/dashboard/AdminDashboard";
import TeacherDashboard from "../teacher/dashboard/TeacherDashboard";
import StudentDasboard from "../student/dashboard/StudentDashboard";
import ParentDashboard from "../parent/dashboard/ParentDashboard";

// Students
import StudentGrid from "../peoples/students/student-grid";
import AddStudent from "../peoples/students/add-student";
import StudentList from "../peoples/students/student-list";
import StudentLibrary from "../peoples/students/student-details/studentLibrary";
import StudentDetails from "../peoples/students/student-details/studentDetails";
import StudentFees from "../peoples/students/student-details/studentFees";
import StudentLeaves from "../peoples/students/student-details/studentLeaves";
import StudentResult from "../peoples/students/student-details/studentResult";
import StudentTimeTable from "../peoples/students/student-details/studentTimeTable";
import StudentPromotion from "../peoples/students/student-promotion";
import HomeworkList from "../student/homework/HomeworkList";

// Teachers
import TeacherGrid from "../peoples/teacher/teacher-grid";
import TeacherForm from "../peoples/teacher/teacherForm";
import TeacherList from "../peoples/teacher/teacher-list";
import TeacherDetails from "../peoples/teacher/teacher-details/teacherDetails";
import TeachersRoutine from "../peoples/teacher/teacher-details/teachersRoutine";
import TeacherSalary from "../peoples/teacher/teacher-details/teacherSalary";
import TeacherLeave from "../peoples/teacher/teacher-details/teacherLeave";
import TeacherLibrary from "../peoples/teacher/teacher-details/teacherLibrary";

// Parents & Guardians
import ParentGrid from "../peoples/parent/parent-grid";
import ParentList from "../peoples/parent/parent-list";
import GuardianGrid from "../peoples/guardian/guardian-grid";
import GuardianList from "../peoples/guardian/guardian-list";

// Academic
import AcademicReason from "../academic/academic-reason";
import ClassSyllabus from "../academic/class-syllabus";
import ClassSubject from "../academic/class-subject";
import ClassSection from "../academic/class-section";
import ClassRoom from "../academic/class-room";
import ClassRoutine from "../academic/class-routine";
import ScheduleClasses from "../academic/schedule-classes";
import Classes from "../academic/classes";
import ClassHomeWork from "../academic/class-home-work";
import ClassTimetable from "../academic/class-timetable";
import Exam from "../academic/examinations/exam";
import ExamSchedule from "../academic/examinations/exam-schedule";
import Grade from "../academic/examinations/grade";
import ExamResult from "../academic/examinations/exam-results";
import ExamAttendance from "../academic/examinations/exam-attendance";

// HRM
import Staff from "../hrm/staff-list/staff";
import Departments from "../hrm/departments";
import Payroll from "../hrm/payroll";
import Holiday from "../hrm/holidays";
import Designation from "../hrm/designation";
import ListLeaves from "../hrm/leaves/list-leaves";
import StaffDetails from "../hrm/staff-list/staff-details.tsx";
import StaffPayRoll from "../hrm/staff-list/staff-payroll.tsx";
import StaffLeave from "../hrm/staff-list/staff-leave";
import ApproveRequest from "../hrm/leaves/approve-request";
import StudentAttendance from "../hrm/attendance/student-attendance";
import TeacherAttendance from "../hrm/attendance/teacher-attendance";
import StaffAttendance from "../hrm/attendance/staff-attendance";
import AddStaff from "../hrm/staff-list/add-staff";
import EditStaff from "../hrm/staff-list/edit-staff";
import StaffsAttendance from "../hrm/staff-list/staffs-attendance";

// Management
import FeesGroup from "../management/feescollection/feesGroup";
import FeesTypes from "../management/feescollection/feesTypes";
import FeesMaster from "../management/feescollection/feesMaster";
import FeesAssign from "../management/feescollection/feesAssign";
import CollectFees from "../management/feescollection/collectFees";
import LibraryMember from "../management/library/libraryMember";
import Books from "../management/library/books";
import IssueBook from "../management/library/issuesBook";
import ReturnBook from "../management/library/returnBook";
import SportsList from "../management/sports/sportsList";
import PlayersList from "../management/sports/playersList";
import HostelRooms from "../management/hostel/hostelRooms";
import HostelList from "../management/hostel/hostelList";
import HostelType from "../management/hostel/hostelType";
import TransportRoutes from "../management/transport/transportRoutes";
import TransportPickupPoints from "../management/transport/transportPickupPoints";
import TransportVehicleDrivers from "../management/transport/transportVehicleDrivers";
import TransportVehicle from "../management/transport/transportVehicle";
import TransportAssignVehicle from "../management/transport/transportAssignVehicle";

// Accounts
import AccountsIncome from "../accounts/accounts-income";
import AccountsInvoices from "../accounts/accounts-invoices";
import AccountsTransactions from "../accounts/accounts-transactions";
import AddInvoice from "../accounts/add-invoice";
import EditInvoice from "../accounts/edit-invoice";
import Expense from "../accounts/expense";
import ExpensesCategory from "../accounts/expenses-category";
import Invoice from "../accounts/invoice";

// Announcements
import NoticeBoard from "../shared/pages/NoticeBoard";
import Events from "../announcements/events";

// Reports
import FeesReport from "../report/fees-report/feesReport";
import LeaveReport from "../report/leave-report/leaveReport";
import GradeReport from "../report/grade-report/gradeReport";
import StudentReport from "../report/student-report/studentReport";
import ClassReport from "../report/class-report/classReport";
import AttendanceReport from "../report/attendance-report/attendanceReport";
import StudentAttendanceType from "../report/attendance-report/studentAttendanceType";
import StaffReport from "../report/attendance-report/staffReport";
import TeacherReport from "../report/attendance-report/teacherReport";
import StaffDayWise from "../report/attendance-report/staffDayWise";
import TeacherDayWise from "../report/attendance-report/teacherDayWise";
import StudentDayWise from "../report/attendance-report/studentDayWise";
import DailyAttendance from "../report/attendance-report/dailyAttendance";

// Settings
// import Profilesettings from "../settings/generalSettings/profile";
// import Securitysettings from "../settings/generalSettings/security";
// import Notificationssettings from "../settings/generalSettings/notifications";
// import ConnectedApps from "../settings/generalSettings/connectedApps";
// import CompanySettings from "../settings/websiteSettings/companySettings";
// import Localization from "../settings/websiteSettings/localization";
// import Prefixes from "../settings/websiteSettings/prefixes";
// import Socialauthentication from "../settings/websiteSettings/socialAuthentication";
// import Languagesettings from "../settings/websiteSettings/language";
// import InvoiceSettings from "../settings/appSettings/invoiceSettings";
// import CustomFields from "../settings/appSettings/customFields";
// import EmailSettings from "../settings/systemSettings/emailSettings";
// import Emailtemplates from "../settings/systemSettings/email-templates";
// import SmsSettings from "../settings/systemSettings/smsSettings";
// import OtpSettings from "../settings/systemSettings/otp-settings";
// import GdprCookies from "../settings/systemSettings/gdprCookies";
// import PaymentGateways from "../settings/financialSettings/paymentGateways";
// import TaxRates from "../settings/financialSettings/taxRates";
// import SchoolSettings from "../settings/academicSettings/schoolSettings";
// import Religion from "../settings/academicSettings/religion";
// import Storage from "../settings/otherSettings/storage";
// import BanIpAddress from "../settings/otherSettings/banIpaddress";

// Pages
import Profile from "../pages/profile";
import NotificationActivities from "../pages/profile/activities";

const routes = all_routes;

export const publicRoutes = [
  // Dashboards
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
  },
  {
    path: routes.teacherDashboard,
    element: <TeacherDashboard />,
    route: Route,
  },
  {
    path: routes.studentDashboard,
    element: <StudentDasboard />,
    route: Route,
  },
  {
    path: routes.parentDashboard,
    element: <ParentDashboard />,
    route: Route,
  },

  // Essential utilities
  {
    path: routes.calendar,
    element: <Calendar />,
    route: Route,
  },
  {
    path: routes.dataTables,
    element: <DataTable />,
    route: Route,
  },
  {
    path: routes.tablesBasic,
    element: <BasicTable />,
    route: Route,
  },

  // Students
  {
    path: routes.studentGrid,
    element: <StudentGrid />,
  },
  {
    path: routes.studentList,
    element: <StudentList />,
  },
  {
    path: routes.addStudent,
    element: <AddStudent />,
  },
  {
    path: routes.editStudent,
    element: <AddStudent />,
  },
  {
    path: routes.studentLibrary,
    element: <StudentLibrary />,
  },
  {
    path: routes.studentDetail,
    element: <StudentDetails />,
  },
  {
    path: routes.studentFees,
    element: <StudentFees />,
  },
  {
    path: routes.studentLeaves,
    element: <StudentLeaves />,
  },
  {
    path: routes.studentResult,
    element: <StudentResult />,
  },
  {
    path: routes.studentTimeTable,
    element: <StudentTimeTable />,
  },
  {
    path: routes.studentPromotion,
    element: <StudentPromotion />,
  },
  {
    path: routes.attendanceView,
    element: <AttendanceView />,
    route: Route,
  },
  {
    path: routes.studentGrades,
    element: <StudentGrades />,
    route: Route,
  },
  {
    path: routes.homeworkList,
    element: <HomeworkList />,
    route: Route,
  },

  // Teachers
  {
    path: routes.teacherGrid,
    element: <TeacherGrid />,
  },
  {
    path: routes.teacherList,
    element: <TeacherList />,
  },
  {
    path: routes.addTeacher,
    element: <TeacherForm />,
  },
  {
    path: routes.editTeacher,
    element: <TeacherForm />,
  },
  {
    path: routes.teacherDetails,
    element: <TeacherDetails />,
  },
  {
    path: routes.teachersRoutine,
    element: <TeachersRoutine />,
  },
  {
    path: routes.teacherSalary,
    element: <TeacherSalary />,
  },
  {
    path: routes.teacherLeaves,
    element: <TeacherLeave />,
  },
  {
    path: routes.teacherLibrary,
    element: <TeacherLibrary />,
  },
  {
    path: routes.teacherSchedule,
    element: <TeacherSchedule />,
    route: Route,
  },
  {
    path: routes.gradeEntry,
    element: <GradeEntry />,
    route: Route,
  },

  // Parents & Guardians
  {
    path: routes.parentGrid,
    element: <ParentGrid />,
  },
  {
    path: routes.parentList,
    element: <ParentList />,
  },
  {
    path: routes.guardiansGrid,
    element: <GuardianGrid />,
  },
  {
    path: routes.guardiansList,
    element: <GuardianList />,
  },

  // Academic
  {
    path: routes.AcademicReason,
    element: <AcademicReason />,
  },
  {
    path: routes.classSyllabus,
    element: <ClassSyllabus />,
  },
  {
    path: routes.classSubject,
    element: <ClassSubject />,
  },
  {
    path: routes.classSection,
    element: <ClassSection />,
  },
  {
    path: routes.classRoom,
    element: <ClassRoom />,
  },
  {
    path: routes.classRoutine,
    element: <ClassRoutine />,
  },
  {
    path: routes.sheduleClasses,
    element: <ScheduleClasses />,
  },
  {
    path: routes.classes,
    element: <Classes />,
  },
  {
    path: routes.classHomeWork,
    element: <ClassHomeWork />,
  },
  {
    path: routes.classTimetable,
    element: <ClassTimetable />,
  },
  {
    path: routes.exam,
    element: <Exam />,
  },
  {
    path: routes.examSchedule,
    element: <ExamSchedule />,
  },
  {
    path: routes.grade,
    element: <Grade />,
  },
  {
    path: routes.examResult,
    element: <ExamResult />,
  },
  {
    path: routes.examAttendance,
    element: <ExamAttendance />,
  },

  // HRM
  {
    path: routes.staff,
    element: <Staff />,
  },
  {
    path: routes.departments,
    element: <Departments />,
  },
  {
    path: routes.payroll,
    element: <Payroll />,
  },
  {
    path: routes.holidays,
    element: <Holiday />,
  },
  {
    path: routes.designation,
    element: <Designation />,
  },
  {
    path: routes.listLeaves,
    element: <ListLeaves />,
  },
  {
    path: routes.staffDetails,
    element: <StaffDetails />,
  },
  {
    path: routes.staffPayroll,
    element: <StaffPayRoll />,
  },
  {
    path: routes.staffLeave,
    element: <StaffLeave />,
  },
  {
    path: routes.approveRequest,
    element: <ApproveRequest />,
  },
  {
    path: routes.studentAttendance,
    element: <StudentAttendance />,
  },
  {
    path: routes.teacherAttendance,
    element: <TeacherAttendance />,
  },
  {
    path: routes.staffAttendance,
    element: <StaffAttendance />,
  },
  {
    path: routes.staffsAttendance,
    element: <StaffsAttendance />,
  },
  {
    path: routes.addStaff,
    element: <AddStaff />,
  },
  {
    path: routes.editStaff,
    element: <EditStaff />,
  },

  // Management
  {
    path: routes.feesGroup,
    element: <FeesGroup />,
  },
  {
    path: routes.feesType,
    element: <FeesTypes />,
  },
  {
    path: routes.feesMaster,
    element: <FeesMaster />,
  },
  {
    path: routes.feesAssign,
    element: <FeesAssign />,
  },
  {
    path: routes.collectFees,
    element: <CollectFees />,
  },
  {
    path: routes.libraryMembers,
    element: <LibraryMember />,
  },
  {
    path: routes.libraryBooks,
    element: <Books />,
  },
  {
    path: routes.libraryIssueBook,
    element: <IssueBook />,
  },
  {
    path: routes.libraryReturn,
    element: <ReturnBook />,
  },
  {
    path: routes.sportsList,
    element: <SportsList />,
  },
  {
    path: routes.playerList,
    element: <PlayersList />,
  },
  {
    path: routes.hostelRoom,
    element: <HostelRooms />,
  },
  {
    path: routes.hostelType,
    element: <HostelType />,
  },
  {
    path: routes.hostelList,
    element: <HostelList />,
  },
  {
    path: routes.transportRoutes,
    element: <TransportRoutes />,
  },
  {
    path: routes.transportAssignVehicle,
    element: <TransportAssignVehicle />,
  },
  {
    path: routes.transportPickupPoints,
    element: <TransportPickupPoints />,
  },
  {
    path: routes.transportVehicleDrivers,
    element: <TransportVehicleDrivers />,
  },
  {
    path: routes.transportVehicle,
    element: <TransportVehicle />,
  },

  // Accounts
  {
    path: routes.accountsIncome,
    element: <AccountsIncome />,
  },
  {
    path: routes.accountsInvoices,
    element: <AccountsInvoices />,
  },
  {
    path: routes.accountsTransactions,
    element: <AccountsTransactions />,
  },
  {
    path: routes.addInvoice,
    element: <AddInvoice />,
  },
  {
    path: routes.editInvoice,
    element: <EditInvoice />,
  },
  {
    path: routes.expense,
    element: <Expense />,
  },
  {
    path: routes.expenseCategory,
    element: <ExpensesCategory />,
  },
  {
    path: routes.invoice,
    element: <Invoice />,
  },

  // Announcements
  {
    path: routes.events,
    element: <Events />,
  },
  {
    path: routes.noticeBoard,
    element: <NoticeBoard />,
  },

  // Reports
  {
    path: routes.feesReport,
    element: <FeesReport />,
  },
  {
    path: routes.leaveReport,
    element: <LeaveReport />,
  },
  {
    path: routes.gradeReport,
    element: <GradeReport />,
  },
  {
    path: routes.studentReport,
    element: <StudentReport />,
  },
  {
    path: routes.classReport,
    element: <ClassReport />,
  },
  {
    path: routes.attendanceReport,
    element: <AttendanceReport />,
  },
  {
    path: routes.studentAttendanceType,
    element: <StudentAttendanceType />,
  },
  {
    path: routes.dailyAttendance,
    element: <DailyAttendance />,
  },
  {
    path: routes.studentDayWise,
    element: <StudentDayWise />,
  },
  {
    path: routes.teacherDayWise,
    element: <TeacherDayWise />,
  },
  {
    path: routes.staffDayWise,
    element: <StaffDayWise />,
  },
  {
    path: routes.teacherReport,
    element: <TeacherReport />,
  },
  {
    path: routes.staffReport,
    element: <StaffReport />,
  },
  {
    path: routes.reportedIssues,
    element: <ReportedIssues />,
    route: Route,
  },

  // Settings
  // {
  //   path: routes.profilesettings,
  //   element: <Profilesettings />,
  // },
  // {
  //   path: routes.securitysettings,
  //   element: <Securitysettings />,
  // },
  // {
  //   path: routes.notificationssettings,
  //   element: <Notificationssettings />,
  // },
  // {
  //   path: routes.connectedApps,
  //   element: <ConnectedApps />,
  // },
  // {
  //   path: routes.companySettings,
  //   element: <CompanySettings />,
  // },
  // {
  //   path: routes.localization,
  //   element: <Localization />,
  // },
  // {
  //   path: routes.prefixes,
  //   element: <Prefixes />,
  // },
  // {
  //   path: routes.socialAuthentication,
  //   element: <Socialauthentication />,
  // },
  // {
  //   path: routes.language,
  //   element: <Languagesettings />,
  // },
  // {
  //   path: routes.invoiceSettings,
  //   element: <InvoiceSettings />,
  // },
  // {
  //   path: routes.customFields,
  //   element: <CustomFields />,
  // },
  // {
  //   path: routes.emailSettings,
  //   element: <EmailSettings />,
  // },
  // {
  //   path: routes.emailTemplates,
  //   element: <Emailtemplates />,
  // },
  // {
  //   path: routes.smsSettings,
  //   element: <SmsSettings />,
  // },
  // {
  //   path: routes.optSettings,
  //   element: <OtpSettings />,
  // },
  // {
  //   path: routes.gdprCookies,
  //   element: <GdprCookies />,
  // },
  // {
  //   path: routes.paymentGateways,
  //   element: <PaymentGateways />,
  // },
  // {
  //   path: routes.taxRates,
  //   element: <TaxRates />,
  // },
  // {
  //   path: routes.schoolSettings,
  //   element: <SchoolSettings />,
  // },
  // {
  //   path: routes.religion,
  //   element: <Religion />,
  // },
  // {
  //   path: routes.storage,
  //   element: <Storage />,
  // },
  // {
  //   path: routes.banIpAddress,
  //   element: <BanIpAddress />,
  // },

  // // Content/Location
  // {
  //   path: routes.cities,
  //   element: <Cities />,
  // },
  // {
  //   path: routes.states,
  //   element: <States />,
  // },
  // {
  //   path: routes.countries,
  //   element: <Countries />,
  // },

  // Pages
  {
    path: routes.profile,
    element: <Profile />,
  },
  {
    path: routes.activity,
    element: <NotificationActivities />,
  },

  // Role-based Admin routes
  {
    path: routes.userManagement,
    element: <UserManagement />,
    route: Route,
  },
  {
    path: routes.documentRequestsManagement,
    element: <DocumentRequestsManagement />,
    route: Route,
  },
  {
    path: routes.schoolSchedule,
    element: <SchoolSchedule />,
    route: Route,
  },
  {
    path: routes.adminNotifications,
    element: <NotificationSettings />,
    route: Route,
  },
  {
    path: routes.adminSettings,
    element: <AdminSettings />,
    route: Route,
  },

  // Role-based Teacher routes
  {
    path: routes.attendanceTracker,
    element: <AttendanceTracker />,
    route: Route,
  },
  {
    path: routes.manageHomework,
    element: <ManageHomework />,
    route: Route,
  },
  {
    path: routes.alertParents,
    element: <AlertParents />,
    route: Route,
  },

  // Teacher Module - Complete App Flow Routes
  {
    path: routes.teacherTasks,
    element: <TeacherTasks />,
    route: Route,
  },
  {
    path: routes.teacherMenu,
    element: <TeacherMenu />,
    route: Route,
  },
  {
    path: routes.teacherClasses,
    element: <TeacherClasses />,
    route: Route,
  },
  {
    path: routes.teacherStudentsDirectory,
    element: <StudentsDirectory />,
    route: Route,
  },
  {
    path: routes.teacherReportStudent,
    element: <ReportStudent />,
    route: Route,
  },
  {
    path: routes.teacherDocumentRequests,
    element: <DocumentRequests />,
    route: Route,
  },
  {
    path: routes.teacherLeaveRequests,
    element: <LeaveRequests />,
    route: Route,
  },
  {
    path: routes.teacherContactAdmin,
    element: <ContactAdmin />,
    route: Route,
  },
  {
    path: routes.teacherReportIssues,
    element: <ReportIssues />,
    route: Route,
  },

  // Teacher Module - Additional Component Routes
  {
    path: routes.teacherProfile,
    element: <TeacherProfile />,
    route: Route,
  },
  {
    path: routes.teacherSettings,
    element: <TeacherSettings />,
    route: Route,
  },
  {
    path: routes.teacherHelp,
    element: <TeacherHelp />,
    route: Route,
  },
  {
    path: routes.teacherMessages,
    element: <TeacherMessages />,
    route: Route,
  },
  {
    path: routes.teacherNotifications,
    element: <TeacherNotifications />,
    route: Route,
  },
  {
    path: routes.teacherAttendanceHistory,
    element: <TeacherAttendanceHistory />,
    route: Route,
  },
  {
    path: routes.teacherHomeworkHistory,
    element: <TeacherHomeworkHistory />,
    route: Route,
  },
  {
    path: routes.teacherAnnouncementsSent,
    element: <AnnouncementsSent />,
    route: Route,
  },
  {
    path: routes.teacherAnalytics,
    element: <TeacherAnalytics />,
    route: Route,
  },
  {
    path: routes.teacherGradesOverview,
    element: <TeacherGradesOverview />,
    route: Route,
  },
  {
    path: routes.teacherGradesOverview,
    element: <TeacherGradesOverview />,
    route: Route,
  },

  // Role-based Student routes
  {
    path: routes.gradeList,
    element: <GradeList />,
    route: Route,
  },
  {
    path: routes.documentRequestForm,
    element: <DocumentRequestForm />,
    route: Route,
  },
  {
    path: routes.todoList,
    element: <ToDoList />,
    route: Route,
  },
  {
    path: routes.studentNoticeBoard,
    element: <NoticeBoard />,
    route: Route,
  },
  {
    path: routes.studentClasses,
    element: <StudentClasses />,
    route: Route,
  },
  {
    path: routes.studentTasks,
    element: <StudentTasks />,
    route: Route,
  },
  {
    path: routes.studentMenu,
    element: <StudentMenu />,
    route: Route,
  },
  {
    path: routes.studentEvents,
    element: <StudentEvents />,
    route: Route,
  },
  {
    path: routes.studentMessages,
    element: <StudentMessages />,
    route: Route,
  },
  {
    path: routes.studentNotifications,
    element: <StudentNotifications />,
    route: Route,
  },
  {
    path: routes.studentHelp,
    element: <StudentHelp />,
    route: Route,
  },
  {
    path: routes.studentSettings,
    element: <StudentSettings />,
    route: Route,
  },
  {
    path: routes.studentSettings,
    element: <StudentSettings />,
    route: Route,
  },

  // Role-based Parent routes
  {
    path: routes.viewStudentProfile,
    element: <ViewStudentProfile />,
    route: Route,
  },
  {
    path: routes.paymentHistory,
    element: <PaymentHistory />,
    route: Route,
  },
  {
    path: routes.parentDocumentRequests,
    element: <ParentDocumentRequests />,
    route: Route,
  },

  // Parent Module - New Routes
  {
    path: routes.parentHomework,
    element: <ParentHomework />,
    route: Route,
  },
  {
    path: routes.parentTasks,
    element: <ParentTasks />,
    route: Route,
  },
  {
    path: routes.parentMenu,
    element: <ParentMenu />,
    route: Route,
  },
  {
    path: routes.parentAttendanceHistory,
    element: <ParentAttendanceHistory />,
    route: Route,
  },
  {
    path: routes.parentSchedule,
    element: <ParentSchedule />,
    route: Route,
  },
  {
    path: routes.parentHomeworkHistory,
    element: <ParentHomeworkHistory />,
    route: Route,
  },
  {
    path: routes.parentGradesOverview,
    element: <ParentGradesOverview />,
    route: Route,
  },
  {
    path: routes.parentPaymentsHistory,
    element: <ParentPaymentsHistory />,
    route: Route,
  },
  {
    path: routes.parentDocuments,
    element: <ParentDocuments />,
    route: Route,
  },
  {
    path: routes.parentEventsCalendar,
    element: <ParentEventsCalendar />,
    route: Route,
  },
  {
    path: routes.parentMessages,
    element: <ParentMessages />,
    route: Route,
  },
  {
    path: routes.parentNotifications,
    element: <ParentNotifications />,
    route: Route,
  },
  {
    path: routes.parentSettings,
    element: <ParentSettings />,
    route: Route,
  },
  {
    path: routes.parentHelp,
    element: <ParentHelp />,
    route: Route,
  },

  // Role-based Support routes
  {
    path: routes.supportDashboard,
    element: <SupportDashboard />,
    route: Route,
  },
  {
    path: routes.supportUserAccess,
    element: <SupportUserAccess />,
    route: Route,
  },
  {
    path: routes.allDocumentRequests,
    element: <AllDocumentRequests />,
    route: Route,
  },
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
  },

  // Admin routes
  {
    path: routes.userManagement,
    element: <UserManagement />,
    route: Route,
  },
  {
    path: routes.documentRequestsManagement,
    element: <DocumentRequestsManagement />,
    route: Route,
  },
  {
    path: routes.schoolSchedule,
    element: <SchoolSchedule />,
    route: Route,
  },

  // Teacher routes
  {
    path: routes.attendanceTracker,
    element: <AttendanceTracker />,
    route: Route,
  },
  {
    path: routes.manageHomework,
    element: <ManageHomework />,
    route: Route,
  },
  {
    path: routes.alertParents,
    element: <AlertParents />,
    route: Route,
  },

  // Teacher Module - Complete App Flow Routes in Auth
  {
    path: routes.teacherTasks,
    element: <TeacherTasks />,
    route: Route,
  },
  {
    path: routes.teacherMenu,
    element: <TeacherMenu />,
    route: Route,
  },
  {
    path: routes.teacherClasses,
    element: <TeacherClasses />,
    route: Route,
  },
  {
    path: routes.teacherStudentsDirectory,
    element: <StudentsDirectory />,
    route: Route,
  },
  {
    path: routes.teacherReportStudent,
    element: <ReportStudent />,
    route: Route,
  },
  {
    path: routes.teacherDocumentRequests,
    element: <DocumentRequests />,
    route: Route,
  },
  {
    path: routes.teacherLeaveRequests,
    element: <LeaveRequests />,
    route: Route,
  },
  {
    path: routes.teacherContactAdmin,
    element: <ContactAdmin />,
    route: Route,
  },
  {
    path: routes.teacherReportIssues,
    element: <ReportIssues />,
    route: Route,
  },

  // Teacher Module - Additional Component Routes in Auth
  {
    path: routes.teacherProfile,
    element: <TeacherProfile />,
    route: Route,
  },
  {
    path: routes.teacherSettings,
    element: <TeacherSettings />,
    route: Route,
  },
  {
    path: routes.teacherHelp,
    element: <TeacherHelp />,
    route: Route,
  },
  {
    path: routes.teacherMessages,
    element: <TeacherMessages />,
    route: Route,
  },
  {
    path: routes.teacherNotifications,
    element: <TeacherNotifications />,
    route: Route,
  },
  {
    path: routes.teacherAttendanceHistory,
    element: <TeacherAttendanceHistory />,
    route: Route,
  },
  {
    path: routes.teacherHomeworkHistory,
    element: <TeacherHomeworkHistory />,
    route: Route,
  },
  {
    path: routes.teacherAnnouncementsSent,
    element: <AnnouncementsSent />,
    route: Route,
  },
  {
    path: routes.teacherAnalytics,
    element: <TeacherAnalytics />,
    route: Route,
  },

  // Student routes
  {
    path: routes.gradeList,
    element: <GradeList />,
    route: Route,
  },
  {
    path: routes.documentRequestForm,
    element: <DocumentRequestForm />,
    route: Route,
  },
  {
    path: routes.studentClasses,
    element: <StudentClasses />,
    route: Route,
  },
  {
    path: routes.studentTasks,
    element: <StudentTasks />,
    route: Route,
  },
  {
    path: routes.studentMenu,
    element: <StudentMenu />,
    route: Route,
  },
  {
    path: routes.studentEvents,
    element: <StudentEvents />,
    route: Route,
  },
  {
    path: routes.studentMessages,
    element: <StudentMessages />,
    route: Route,
  },
  {
    path: routes.studentNotifications,
    element: <StudentNotifications />,
    route: Route,
  },
  {
    path: routes.studentHelp,
    element: <StudentHelp />,
    route: Route,
  },

  // Parent routes
  {
    path: routes.viewStudentProfile,
    element: <ViewStudentProfile />,
    route: Route,
  },
  {
    path: routes.paymentHistory,
    element: <PaymentHistory />,
    route: Route,
  },

  // Parent Module - New Routes in Auth
  {
    path: routes.parentHomework,
    element: <ParentHomework />,
    route: Route,
  },
  {
    path: routes.parentTasks,
    element: <ParentTasks />,
    route: Route,
  },
  {
    path: routes.parentMenu,
    element: <ParentMenu />,
    route: Route,
  },
  {
    path: routes.parentAttendanceHistory,
    element: <ParentAttendanceHistory />,
    route: Route,
  },
  {
    path: routes.parentSchedule,
    element: <ParentSchedule />,
    route: Route,
  },
  {
    path: routes.parentHomeworkHistory,
    element: <ParentHomeworkHistory />,
    route: Route,
  },
  {
    path: routes.parentGradesOverview,
    element: <ParentGradesOverview />,
    route: Route,
  },
  {
    path: routes.parentPaymentsHistory,
    element: <ParentPaymentsHistory />,
    route: Route,
  },
  // {
  //   path: routes.parentDocuments,
  //   element: <ParentDocuments />,
  //   route: Route,
  // },
  {
    path: routes.parentEventsCalendar,
    element: <ParentEventsCalendar />,
    route: Route,
  },
  // {
  //   path: routes.parentMessages,
  //   element: <ParentMessages />,
  //   route: Route,
  // },
  {
    path: routes.parentNotifications,
    element: <ParentNotifications />,
    route: Route,
  },
  // {
  //   path: routes.parentSettings,
  //   element: <ParentSettings />,
  //   route: Route,
  // },
  // {
  //   path: routes.parentHelp,
  //   element: <ParentHelp />,
  //   route: Route,
  // },

  // Support routes
  {
    path: routes.supportDashboard,
    element: <SupportDashboard />,
    route: Route,
  },
  {
    path: routes.supportUserAccess,
    element: <SupportUserAccess />,
    route: Route,
  },
];
